import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../../../music24/components/primitives/Panel';
import styles from './SMLRailPanel.module.scss';

interface SMLRailPanelProps {
  /** The title of the panel. It goes in the head row of the box. */
  label?: string;
  /** Actions at the right end of the head row (for example a close button). */
  right?: React.ReactNode;
  /** Fill the rail's leftover height so the panel's content can scroll. */
  grow?: boolean;
}

/** A box in the Creator rail: the Panel primitive, with the label in its head row. */
const SMLRailPanelComponent: React.FC<React.PropsWithChildren<SMLRailPanelProps>> = ({
  label,
  right,
  grow,
  children,
}) => {
  return (
    <Panel className={clsx(grow === true && styles.grow)}>
      {label !== undefined ? <PanelHead title={label} right={right} /> : null}
      <PanelBody className={clsx(grow === true && styles.growBody)}>{children}</PanelBody>
    </Panel>
  );
};

export const SMLRailPanel = TypedMemo(SMLRailPanelComponent);
